import { client } from "./index";

// Returns and refunds of one website (/api/admin/sites/:siteId/returns)
const base = (siteId) => `/admin/sites/${siteId}/returns`;
export const getReturnPolicy = (siteId) => client.get(`${base(siteId)}/policy`);
export const saveReturnPolicy = (siteId, policy) => client.put(`${base(siteId)}/policy`, policy);
export const getReturns = (siteId, status) => client.get(base(siteId), { params: status ? { status } : {} });
// { decision: approve|reject, resolution: refund|replace, refundAmount, note }
export const decideReturn = (siteId, requestId, payload) => client.put(`${base(siteId)}/${requestId}/decide`, payload);
// Marks that an unboxing video was asked for; returns the WhatsApp link with the message to send
export const requestUnboxingVideo = (siteId, requestId) => client.post(`${base(siteId)}/${requestId}/video`);
